import { useSearchParamsState } from 'hooks/useSearchParamState';
import { useStore } from 'hooks/useStore';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authServices } from 'services/authServices';

const useLoginFailureScreenLogic = () => {
  const {
    UserStore: { isUserLoggedIn },
  } = useStore();
  const [reason] = useSearchParamsState('reason', '');
  const [loginFailureReason, setLoginFailureReason] = useState('');
  const [isLoginRedirectLinkLoading, setIsLoginRedirectLinkLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      setIsLoginRedirectLinkLoading(true);
      const res = await authServices.initiateLogin();
      window.location.href = res.loginRedirectUrl;
    } catch {
      setIsLoginRedirectLinkLoading(false);
    }
  };

  const handleNavigateToHome = () => {
    navigate('/');
  };

  useEffect(() => {
    if (reason) {
      setLoginFailureReason(reason);
    }
    console.log({ reason });
  }, [reason]);

  useEffect(() => {
    if (isUserLoggedIn()) {
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run on mount only
  }, []);

  return {
    loginFailureReason,
    handleLogin,
    handleNavigateToHome,
    isLoginRedirectLinkLoading,
  };
};

export default useLoginFailureScreenLogic;
